import * as React from 'react';
import {styled} from '@mui/material/styles';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import DeveloperBoardOutlinedIcon from '@mui/icons-material/DeveloperBoardOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import {
    Card,
    CardContent,
    Dialog, DialogActions, DialogContent,
    DialogTitle,
    FormControl, FormControlLabel,
    FormGroup, FormLabel,
    Grid, MenuItem, Radio, RadioGroup, Select, Slide,
    Stack, Switch,
    Tooltip
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {useContext, useEffect, useState} from "react";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import {Person2Outlined} from "@mui/icons-material";
import {UserContext} from "../../../Context/UserContext";
import {LanguageContext} from "../../../Context/LanguageContext";
import Typography from "@mui/material/Typography";
import LinkIcon from "@mui/icons-material/Link";
import {useTheme} from '@mui/material/styles';
import {useNavigate} from "react-router";
import {TokenContext} from "../../../Context/TokenContext";
import {TranslationContext} from "../../../Context/TranslationContext";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CategoryIcon from '@mui/icons-material/Category';
import LanguageIcon from '@mui/icons-material/Language';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import GroupIcon from '@mui/icons-material/Group';
import EuroIcon from '@mui/icons-material/Euro';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import NotificationSystem from '../../NotificationSystem';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import CloudIcon from '@mui/icons-material/Cloud';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import PublicIcon from '@mui/icons-material/Public';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function SidebarContent(props) {
    const {mode, setMode} = useState();

    const navigate = useNavigate();

    const theme = useTheme();
    // const {translation} = useContext(TranslationContext)
    const _userContext = useContext(UserContext)
    // const _langContext = useContext(LanguageContext)
    const _tokenContext = useContext(TokenContext)

    const [openDialogProfile, setOpenDialogProfile] = React.useState(false);
    const [openDialogInfo, setOpenDialogInfo] = React.useState(false);
    const [openDialogDisconnect, setOpenDialogDisconnect] = React.useState(false);

    const [langs, setLangs] = useState([])


    useEffect(() => {
        // setLangs(_langContext.intersection(_langContext.allLangList, _langContext.availableLangList))
    }, [])


    const linkNav = [
        {
            name: 'Dashboard',
            link: '/',
            section: 'dashboard',
            icon: <AnalyticsOutlinedIcon color="primary"/>
        },
        {
            name: 'Applications',
            link: '/applications',
            section: 'applications',
            icon: <DeveloperBoardOutlinedIcon color="primary"/>
        },
        // {
        //     name: 'Programmes',
        //     link: '/programs',
        //     icon: <ShoppingCartOutlinedIcon color="primary"/>
        // },
        {
            name: 'Prospects',
            link: '/prospects',
            section: 'prospects',
            icon: <PersonSearchIcon color="primary"/>
        },
        {
            name: 'Clients',
            link: '/clients',
            section: 'clients',
            icon: <Person2Outlined color="primary"/>
        },
        {
            name: 'Commandes',
            link: '/orders',
            section: 'orders',
            icon: <ShoppingCartOutlinedIcon color="primary"/>
        },
        {
            name: 'Devis',
            link: '/quotes',
            section: 'quotes',
            icon: <RequestQuoteOutlinedIcon color="primary"/>
        },
        // {
        //     name: 'Projets',
        //     link: '/projets',
        //     icon: <FolderOutlinedIcon color="primary"/>
        // },
        // {
        //     name: 'Événements',
        //     link: '/evenements',
        //     icon: <EventOutlinedIcon color="primary"/>
        // },
        // {
        //     name: 'Drive',
        //     link: '/drive',
        //     icon: <CloudIcon color="primary"/>
        // },
        {
            name: 'Support',
            link: '/tickets',
            section: 'tickets',
            icon: <SupportAgentOutlinedIcon color="primary"/>
        },
        // {
        //     name: 'Documentation',
        //     link: '/documentation',
        //     icon: <MenuBookIcon color="primary"/>,
        //     external:true
        // },
        {
            name: 'Catégories',
            link: '/categories',
            section: 'categories',
            icon: <CategoryIcon color="primary"/>
        },
        {
            name: 'Groupes de clients',
            link: '/client-groups',
            section: 'client-groups',
            icon: <GroupIcon color="primary"/>
        },
        {
            name: 'Grilles tarifaires',
            link: '/pricing-plans',
            section: 'pricing-plans',
            icon: <EuroIcon color="primary"/>
        },
        {
            name: 'Prestations (sites & SEO)',
            link: '/service-packages',
            section: 'service-packages',
            icon: <LanguageIcon color="primary"/>
        },
        {
            name: 'Sites de démo',
            link: '/demo-sites',
            section: 'demo-sites',
            icon: <PublicIcon color="primary"/>
        },
        {
            name: 'Réglages',
            link: '/settings',
            section: 'settings',
            icon: <SettingsOutlinedIcon color="primary"/>
        },
        {
            name: 'Administration',
            icon: <AdminPanelSettingsOutlinedIcon color="primary"/>,
            children: [
                {
                    name: 'Employés',
                    link: '/employes',
                    section: 'employes',
                    icon: <BadgeOutlinedIcon color="primary"/>
                },
                {
                    name: 'Administrateur',
                    link: '/administrateurs',
                    requireSuperAdmin: true,
                    icon: <AdminPanelSettingsOutlinedIcon color="primary"/>
                },
                {
                    name: 'Gestion des groupes',
                    link: '/groupes',
                    section: 'manage-own-group-members',
                    icon: <GroupIcon color="primary"/>
                },
            ]
        },
        // {
        //     name: 'Mail',
        //     link: process.env.REACT_APP_MAIL_MANAGER_URL || 'http://localhost:3011',
        //     icon: <EmailOutlinedIcon color="primary"/>,
        //     external: true,
        // },
    ]

    const isSuperAdmin = _userContext?.userInfo?.is_super_admin === true;
    const userPermissions = _userContext?.userInfo?.permissions || [];
    const isNavVisible = (nav) => {
        if (nav.section === 'dashboard') return true;
        if (nav.requireSuperAdmin) return isSuperAdmin;
        if (!nav.section) return true;
        return isSuperAdmin || userPermissions.includes(nav.section);
    };
    // Un item "parent" (avec children, ex: "Administration") n'a pas de section propre — il est
    // gardé uniquement si au moins un de ses enfants est visible, chaque enfant gardant sa
    // propre règle de visibilité individuelle.
    const visibleLinkNav = linkNav.reduce((acc, nav) => {
        if (nav.children) {
            const visibleChildren = nav.children.filter(isNavVisible);
            if (visibleChildren.length > 0) acc.push({ ...nav, children: visibleChildren });
        } else if (isNavVisible(nav)) {
            acc.push(nav);
        }
        return acc;
    }, []);

    const [openSections, setOpenSections] = useState(() => {
        const initial = {};
        for (const nav of linkNav) {
            if (nav.children?.some(c => c.link === window.location.pathname)) {
                initial[nav.name] = true;
            }
        }
        return initial;
    });
    const toggleSection = (name) => setOpenSections(prev => ({ ...prev, [name]: !prev[name] }));


    const DrawerHeader = styled('div')(({theme}) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(0, 2),
        width: "100%",

        // necessary for content to be below app bar
        ...theme.mixins.toolbar
    }));

    const toggleDrawer = (open) => () => {
        props.setIsOpen(open);
    };

    const t = (translationKey, variables) => {
        // console.log(translation(translationKey, 'Menu.js'))
        // return translationKey
        return translationKey
        // return translation(translationKey, 'Sidebar.json', variables)
    }
    const tCommon = (translationKey, variables) => {
        return  translationKey
        // console.log(translation(translationKey, 'Menu.js'))
        // return translationKey
        // return translation(translationKey, 'Common.json', variables)
    }
    const handleClickOpenDialogProfile = () => {
        setOpenDialogProfile(true);
    };

    const handleCloseDialogProfile = () => {
        setOpenDialogProfile(false);
    };
    const handleClickOpenDialogInfo = () => {
        setOpenDialogInfo(true);
    };

    const handleCloseDialogInfo = () => {
        setOpenDialogInfo(false);
    };

    const handleCloseDialogDisconnect = () => {
        setOpenDialogDisconnect(false);
    };

    console.log(theme.palette.mode)

    return (
        <>
            <Stack
                direction="column"
                justifyContent="space-between"
                // alignItems="center"
                height={'100%'}
                width={'100%'}
                spacing={0}
                sx={{
                    margin: 0,
                    padding: 0
                }}
            >

                <Box
                    sx={{
                        margin: 0,
                        padding: 0
                    }}
                >
                    <DrawerHeader>
                        {
                            props.isOpen && (
                                <>
                                    <h2 style={{color: theme.palette.primary.main}}>{t('ERP/CRM')}</h2>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <NotificationSystem />
                                        <IconButton
                                            onClick={toggleDrawer(false)}>
                                            <ChevronLeftIcon/>
                                        </IconButton>
                                    </Box>
                                </>
                            )
                        }

                        {
                            !props.isOpen && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                    <NotificationSystem />
                                    <IconButton
                                        onClick={toggleDrawer(true)}>
                                        <ChevronRightIcon/>
                                    </IconButton>
                                </Box>
                            )
                        }
                    </DrawerHeader>
                    <Divider style={{width: props.width}}/>
                    <List>
                        {visibleLinkNav.map((nav, index) => nav.children ? (
                            <Box key={index}>
                                <ListItem disablePadding sx={{display: 'block'}} onClick={() => toggleSection(nav.name)}>
                                    <Tooltip title={props.isOpen ? '' : t(nav.name)} placement="left">
                                        <ListItemButton
                                            sx={{
                                                minHeight: 48,
                                                justifyContent: props.isOpen ? 'initial' : 'center',
                                                px: 2.5,
                                            }}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    minWidth: 0,
                                                    mr: props.isOpen ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {nav.icon}
                                            </ListItemIcon>
                                            <Typography sx={{
                                                display: props.isOpen ? 'initial' : 'none',
                                                flexGrow: 1,
                                            }} color={`sidebar.${theme.palette.mode}`}>
                                                {t(nav.name)}
                                            </Typography>
                                            {props.isOpen && (openSections[nav.name] ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />)}
                                        </ListItemButton>
                                    </Tooltip>
                                </ListItem>
                                <Collapse in={props.isOpen && !!openSections[nav.name]} timeout="auto" unmountOnExit>
                                    <List disablePadding>
                                        {nav.children.map((child, childIndex) => (
                                            <ListItem key={childIndex} disablePadding sx={{display: 'block'}} onClick={() => navigate(child.link)}>
                                                <Tooltip title={props.isOpen ? '' : t(child.name)} placement="left">
                                                    <ListItemButton
                                                        sx={{
                                                            minHeight: 44,
                                                            justifyContent: props.isOpen ? 'initial' : 'center',
                                                            pl: props.isOpen ? 5 : 2.5,
                                                            pr: 2.5,
                                                        }}
                                                    >
                                                        <ListItemIcon
                                                            sx={{
                                                                minWidth: 0,
                                                                mr: props.isOpen ? 3 : 'auto',
                                                                justifyContent: 'center',
                                                            }}
                                                        >
                                                            {child.icon}
                                                        </ListItemIcon>
                                                        <Typography sx={{
                                                            display: props.isOpen ? 'initial' : 'none',
                                                        }} color={`sidebar.${theme.palette.mode}`}>
                                                            {t(child.name)}
                                                        </Typography>
                                                    </ListItemButton>
                                                </Tooltip>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Collapse>
                            </Box>
                        ) : (
                            <ListItem key={index} disablePadding sx={{display: 'block'}}
                                      onClick={() => {
                                          if (nav.external) {
                                              window.open(nav.link, '_blank', 'noopener,noreferrer');
                                          } else {
                                              navigate(nav.link);
                                          }
                                      }}
                            >
                                <Tooltip title={props.isOpen ? '' : t(nav.name)} placement="left">
                                    <ListItemButton
                                        sx={{
                                            minHeight: 48,
                                            justifyContent: props.isOpen ? 'initial' : 'center',
                                            px: 2.5,
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                minWidth: 0,
                                                mr: props.isOpen ? 3 : 'auto',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            {nav.icon}
                                        </ListItemIcon>
                                        <Typography sx={{
                                            display: props.isOpen ? 'initial' : 'none',
                                        }} color={`sidebar.${theme.palette.mode}`}>
                                            {t(nav.name)}
                                        </Typography>
                                        {nav.external && props.isOpen && (
                                            <OpenInNewIcon sx={{ fontSize: 14, ml: 0.5, color: 'text.disabled' }} />
                                        )}
                                    </ListItemButton>
                                </Tooltip>
                            </ListItem>
                        ))}
                    </List>
                </Box>
                <Stack>

                    <Box>
                        <Divider/>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-around"
                            alignItems="center"
                        >
                            <Grid xs={12} md={props.isOpen?6:12} textAlign={'center'}>
                                <Tooltip title={props.isOpen ? '' : t("sidebar.account")} placement="left">
                                    <IconButton aria-label="Person2Outlined" onClick={handleClickOpenDialogProfile}
                                                sx={{
                                                    width: '100%',
                                                    borderRadius: 0,
                                                    mr: props.isOpen ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                    color: 'primary.main'
                                                }}

                                    >

                                        <Stack
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="center"

                                        >

                                            <Person2Outlined/>
                                            {
                                                props.isOpen && (<Typography color={`sidebar.${theme.palette.mode}`}>
                                                    {t("sidebar.account")}
                                                </Typography>)
                                            }
                                        </Stack>
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            <Grid xs={12} md={props.isOpen?6:12} textAlign={'center'}>
                                <Tooltip title={props.isOpen ? '' : t("sidebar.about")} placement="left">
                                    <IconButton aria-label="Person2Outlined" onClick={handleClickOpenDialogInfo}
                                                sx={{
                                                    width: '100%',
                                                    borderRadius: 0,
                                                    mr: props.isOpen ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                    color: 'primary.main'
                                                }}

                                    >

                                        <Stack
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="center"

                                        >

                                            <HelpOutlineOutlinedIcon/>
                                            {
                                                props.isOpen && (<Typography color={`sidebar.${theme.palette.mode}`}>
                                                    {t("sidebar.about")}
                                                </Typography>)
                                            }
                                        </Stack>
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                        <Divider/>

                        <Tooltip title={props.isOpen ? '' : t("sidebar.account.disconnected")} placement="left">
                            <IconButton aria-label="Logout"
                                        sx={{
                                            width: '100%',
                                            borderRadius: 0,
                                            mr: props.isOpen ? 3 : 'auto',
                                            justifyContent: 'center',
                                            color: 'primary.main'
                                        }}
                                        onClick={() => {
                                            setOpenDialogDisconnect(true)
                                        }}
                            >
                                <Stack
                                    direction="column"
                                    justifyContent="center"
                                    alignItems="center"

                                >

                                    <LogoutIcon/>
                                    {
                                        props.isOpen && (<Typography color={`sidebar.${theme.palette.mode}`}>
                                            {t("sidebar.account.disconnected")}
                                        </Typography>)
                                    }
                                </Stack>
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Stack>
            </Stack>


            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={openDialogProfile}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseDialogProfile}
                aria-describedby="Dialog profile"

            >
                <DialogTitle>
                    <Typography gutterBottom variant="h4" component="div">
                        {/*    fixme : a changer pour mettre la variable de nom*/}
                        {t("sidebar.account.title", ['Mickaël'])}
                    </Typography>
                </DialogTitle>
                <Divider></Divider>
                <Grid container
                      spacing={3}
                      padding={2}
                >
                    <Grid item xs={12} sm={8} minWidth={0}>
                        <Card elevation={0} style={{border: '1px solid #b2b2b2'}}>
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    {t("sidebar.account.setting.title")}
                                </Typography>
                                <Grid container
                                      direction="column"
                                      justifyContent="left"
                                      alignItems="left">
                                    <Grid item>
                                        <Grid container direction="row" justifyContent={'center'} alignItems={'center'}>
                                            <Grid item xs={2}>
                                                <Typography variant="subtitle1">RTF</Typography>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <FormControl component="fieldset">
                                                    <FormGroup aria-label="position" row={false}>
                                                        <FormControlLabel
                                                            value="0"
                                                            disabled={true}
                                                            control={<Switch color="primary"/>}
                                                        />
                                                    </FormGroup>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container direction="row" justifyContent={'center'} alignItems={'center'}>
                                            <Grid item xs={2}>
                                                <Typography
                                                    variant="subtitle1">{t("sidebar.account.setting.langugage")}</Typography>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <Select
                                                    value=""
                                                    // value={_userContext.userlang()}
                                                    // onChange={(event) => {
                                                    //     _userContext.setUserLang(event.target.value)
                                                    // }}
                                                    fullWidth
                                                >
                                                    {/*{*/}
                                                    {/*    langs.map((lang) => (*/}
                                                    {/*        <MenuItem value={lang.code}>*/}
                                                    {/*            <Grid container direction="row"*/}
                                                    {/*                  justifyContent={'center'}*/}
                                                    {/*                  alignItems={'center'}>*/}
                                                    {/*                <Grid item xs={2}>*/}
                                                    {/*                    <img*/}
                                                    {/*                        src={'data:image/png;base64, ' + lang.image_binary}*/}
                                                    {/*                        height={'25px'}*/}
                                                    {/*                    />*/}
                                                    {/*                </Grid>*/}
                                                    {/*                <Grid item xs={10}>*/}
                                                    {/*                    {lang.name}*/}
                                                    {/*                </Grid>*/}
                                                    {/*            </Grid>*/}
                                                    {/*        </MenuItem>*/}
                                                    {/*    ))*/}
                                                    {/*}*/}

                                                </Select>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction="row" justifyContent={'center'} alignItems={'center'}>
                                        <Grid item xs={2}>
                                            <Typography
                                                variant="subtitle1">mode</Typography>
                                        </Grid>
                                        <Grid item xs={10}>
                                            <FormControl>
                                                <FormLabel id="demo-theme-toggle">Theme</FormLabel>
                                                <RadioGroup
                                                    aria-labelledby="demo-theme-toggle"
                                                    name="theme-toggle"
                                                    row
                                                    value={mode}
                                                    onChange={(event) => setMode(event.target.value)}
                                                >
                                                    <FormControlLabel value="system" control={<Radio/>} label="System"/>
                                                    <FormControlLabel value="light" control={<Radio/>} label="Light"/>
                                                    <FormControlLabel value="dark" control={<Radio/>} label="Dark"/>
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm minWidth={0}>
                        <Card elevation={0} style={{border: '1px solid #b2b2b2'}}>
                            <CardContent>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}>
                                    <LinkIcon color="primary"/>
                                    <Typography variant="h5" component="div">
                                        {t("sidebar.account.helpful_link")}
                                    </Typography>
                                </Box>
                                <List>
                                    <Button
                                        sx={{ width: '100%', mt: '10px' }}
                                        color="primary"
                                        variant="outlined"
                                        href="#outlined-buttons">
                                        {t("sidebar.account.helpful_link.shop")}
                                    </Button>
                                    <Button
                                        sx={{ width: '100%', mt: '10px' }}
                                        color="primary"
                                        variant="outlined"
                                        href="#outlined-buttons">
                                        {t("sidebar.account.helpful_link.GCU")}
                                    </Button>
                                    <Button
                                        sx={{ width: '100%', mt: '10px' }}
                                        color="primary"
                                        variant="outlined"
                                        href="#outlined-buttons">
                                        {t("sidebar.account.helpful_link.FAQ")}
                                    </Button>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <DialogActions sx={{
                    justifyContent: 'flex-start'
                }}>
                    <Button color="primary"
                            onClick={() => {
                                handleCloseDialogProfile()
                                setOpenDialogDisconnect(true)
                            }}>{t("sidebar.account.disconnected")}</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={openDialogInfo}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseDialogInfo}
                aria-describedby="Dialog profile"

            >
                <DialogTitle>
                    <Typography gutterBottom variant="h4" component="div">
                        {t('sidebar.about.title')}
                    </Typography>
                </DialogTitle>
                <Divider></Divider>

                <Card elevation={0} style={{border: '1px solid #b2b2b2'}}>
                    <CardContent>
                        <List>
                            <Button
                                sx={{ width: '100%', mt: '10px' }}
                                color="primary"
                                variant="outlined"
                                onClick={() => {
                                    // handleCloseDialogInfo()
                                    navigate('/changelog')
                                }}
                            >
                                {t('sidebar.about.version_note')}
                            </Button>
                            <Button
                                sx={{ width: '100%', mt: '10px' }}
                                color="primary"
                                variant="outlined"
                                href="#outlined-buttons">
                                {t('sidebar.about.documentation')}
                            </Button>
                            <Button
                                sx={{ width: '100%', mt: '10px' }}
                                color="primary"
                                variant="outlined"
                                href="#outlined-buttons">
                                {t('sidebar.about.GCU')}
                            </Button>
                        </List>
                    </CardContent>
                </Card>

                <DialogActions sx={{
                    justifyContent: 'flex-start'
                }}>
                    {/*{t('sidebar.about.version', [_licenceContext.allInfo.version])}*/}
                </DialogActions>
            </Dialog>

            <Dialog open={openDialogDisconnect} fullWidth={true} width={'md'}
            onClose={handleCloseDialogDisconnect}
            >
                <DialogTitle>
                    <Typography gutterBottom variant="h4" component="div">
                        {t('sidebar.account.disconnected.title')}
                    </Typography>

                </DialogTitle>
                <DialogContent>
                    <Typography gutterBottom component="div">
                        {t('sidebar.account.disconnected.question')}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button className={'Md-Button-color'} onClick={()=>{
                        _tokenContext.disconnect()
                        // window.location.href = 'https://security.alais-studio.fr/auth/disconnect'
                    }}>{tCommon('common.yes')}</Button>
                    <Button className={'Md-Button-color'} onClick={handleCloseDialogDisconnect}>{tCommon('common.no')}</Button>
                </DialogActions>
            </Dialog>

        </>
    )
}